<template>
  <div style="align-self: flex-end;">
    <div class="ThemeSelected">
      <span
        v-show="theme.isSelected"
        class="Icon-s Icon-check-circle"
        style="color: #046ff0"
      />
    </div>

    <div class="ThemeCardContainer">
      <div
        class="ThemeCardBody"
        :style="{
          'font-family': getCardFont,
          'background-color': theme.form_background,
          'background-image': getComputedStyle,
        }"
        @click="$emit('preview-theme')"
      >
        <div
          class="ThemeQuestion"
          :style="{ color: theme.form_questions_text_colour }"
        >
          <div>Question</div>
          <div class="ThemeNotifications">
            <Tooltip position="center">
              <span
                v-show="theme.isDefault"
                slot="trigger"
                class="Icon Icon-bookmark"
                style="padding-right: 5px"
              />
              <span slot="tip">Default theme</span>
            </Tooltip>
            <Tooltip position="center">
              <span
                v-show="theme.isBeenUsedByOtherForms"
                slot="trigger"
                class="Icon Icon-clipboard-list"
                style="padding-right: 5px"
              />
              <span slot="tip">Used by other forms</span>
            </Tooltip>
          </div>
        </div>
        <div :style="{ color: theme.form_answers_text_colour }">
          Answer
        </div>
        <div
          class="Button Button--green Button-themeCard"
          :style="{
            'background-color': theme.form_button_background,
            'border-color' : theme.form_button_border_colour,
            'color': theme.form_button_text_colour,
          }"
        >
          Button
        </div>
      </div>

      <div class="ThemeCard-footer">
        <div
          class="label"
          @click="$emit('preview-theme')"
        >
          {{ theme.name }}
        </div>
        <div @click="$emit('toggle-card-menu')">
          <span class="Icon Icon-ellipsis-h" />
        </div>
      </div>

      <div
        style="position: relative"
        @mouseout="$emit('toggle-card-menu')"
      >
        <div
          v-show="showEditMenu && !theme.isDefault"
          class="ThemeCardMenu"
        >
          <div @click.stop="$emit('edit-theme', id)">
            <span class="Icon-s Icon-pencil" />
            Edit
          </div>
          <div @click.stop="$emit('duplicate-theme', id)">
            <span class="Icon-s Icon-clone" />
            Duplicate
          </div>
          <div style="border-top: 1px solid #000" />
          <div @click.stop="$emit('delete-theme', id)">
            <span class="Icon-s Icon-trash" />
            Delete
          </div>
        </div>
        <div
          v-show="showEditMenu && theme.isDefault"
          class="ThemeCardMenu DuplicateOnly"
        >
          <div @click.stop="$emit('duplicate-theme', id)">
            <span class="Icon-s Icon-clone" />
            Duplicate
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import Tooltip from '../../common/tooltip.vue';

export default {
  components: {
    Tooltip,
  },
  props: {
    theme: {
      type: Object,
      required: true,
    },
    showEditMenu: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: null,
      name: null,
      fontStyle: null,
      form_background: null,
      form_background_image_path: null,
      form_button_background: null,
      form_button_border_colour: null,
      form_button_text_colour: null,
      form_answers_text_colour: null,
      form_questions_text_colour: null,
      ui: {
        themeCardMenu: false,
      },
    };
  },

  computed: {
    ...mapState('forms', {
      form: (state) => state.form,
    }),

    getCardFont: {
      get() {
        const fontFamily = window.__RMP_EVENTS_FONTS_AVAILABLE_FOR_THEMES__.find((font) => {
          return font.id === +this.theme.web_form_theme_font_id;
        });
        return fontFamily.name;
      },
    },

    getComputedStyle: {
      get() {
        return (this.form.type === 'dynamic')
          ? `url("${this.theme.form_background_image_as_base64_string}")`
          : null;
      },
    },
  },
};
</script>
<style lang="scss" scoped>

.ThemeCardContainer {
  border: 1px solid #e3e3e3;
  background-color: white;
  border-radius: 8px;
  margin-right: 5px;
}

.ThemeCardContainer:hover{
    border-radius: 9px;
    border: 1px solid blue;
    cursor: pointer;
  }

.ThemeCardBody {
  padding: 10px;
  width: 170px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: lightblue;
  background-repeat: no-repeat;
  background-size: 100%;
}

.ThemeCardBody div {
  margin-top: 5px;
}

.ThemeCard-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
  overflow: hidden;
  > .label {
    width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.Button-themeCard {
  padding: 3px 8px 3px 8px;
  min-width: 0px;
  margin-bottom: 15px;
}

.ThemeCardMenu {
  cursor: pointer;
  position: absolute;
  display: inline-block;
  background-color: white;
  top: -130px;
  left: 95px;
  width: 80px;
  padding: 8px;
  font-size: x-small;
  border-radius: 4px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 13px 29px 0 rgb(0 0 0 / 11%);

  div {
    margin-bottom: 5px;
  }

  div span {
    margin-right: 3px;
  }

  &.DuplicateOnly {
    top: -75px;
      div:last-child {
      margin-bottom: 0px;
      color: #444;
    }
  }

  div:last-child {
    margin-bottom: 0px;
    color: #db3a46;
  }
}

.ThemeSelected {
  position: relative;
  display: flex;
  justify-content: flex-end;
  top: 10px;
  height: 20px;
}

.ThemeQuestion {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}

.ThemeNotifications {
  position: relative;
  top: -15px;
  height: 28px;

  span {
    padding-right: 5px;
  }
}

::v-deep .Tooltip-content.center{
  left: -50px;
}
</style>
